import { Button } from 'antd'

// import LinkIcon from '@/assets/link1.png'
import BtnContainer from '@/components/BtnContainer'
export default function StepFour() {
  return (
    <div className="min-w-[650px] md:min-w-0">
      <div className="">
        <div className="text-3xl text-light-111 mb-[10px] dark:text-dark-111">
          Monitor Your Node Status
        </div>
      </div>
      <div className="border-1 border-light-555 rounded-2xl mt-[20px] p-4 dark:border-dark-666 dark:text-white">
        <div className="p-2">
          To track your node's performance and manage your staking rewards,
          please visit the
          <a
            className="pl-2 text-light-111 dark:text-dark-111 cursoor cursor-pointer"
            href="/validator/pos"
          >
            My Staking Page
          </a>
          .
        </div>
        <div className="mt-2 p-4 bg-light-106 rounded-2xl flex justify-between items-center dark:bg-dark-106 md:flex-col md:items-start">
          <div className=" dark:text-dark-111">
            For overall network health and global validator status, we recommend
            using{' '}
            <a
              target="_blank"
              href={
                process.env.REACT_APP_CHAINID === '888'
                  ? 'https://www.wanstats.io'
                  : 'https://testnet.wanstats.io'
              }
            >
              wanstats.io
            </a>
          </div>
        </div>
      </div>
      <BtnContainer>
        <Button
          onClick={() => window.open('/validator/pos', '_self')}
          className="w-full rounded-2xl h-[60px] text-[18px] btn dark:bg-dark-102 dark:text-white"
        >
          Finish
        </Button>
      </BtnContainer>
    </div>
  )
}
